import { forEach, findIndex } from "lodash";
import { newConstraintCell } from "../newCell";

const setGroupingWithActualConstraints = (
  grouping,
  constraints,
  allocationProjectLookup,
  columns
) => {
  const constraintsGroupId = grouping.isVirtualDirectConstraintGrouping
    ? grouping.parent.groupId
    : grouping.groupId;
  const constraintsForGrouping = constraints[constraintsGroupId];

  forEach(constraintsForGrouping, (constraint) => {
    const allocationProject =
      allocationProjectLookup[constraint.allocationProjectId];

    // If the allocation project is not found for the constraint, skip it
    if (!allocationProject) {
      return;
    }

    const cell = newConstraintCell(grouping, constraint, allocationProject);
    const cellIndex = findIndex(columns, {
      allocationProjectId: cell.allocationProjectId,
    });

    // eslint-disable-next-line no-param-reassign
    grouping.constraints[cellIndex] = cell;
  });
};

export default setGroupingWithActualConstraints;
